import { PERMISSIONS, useCheckPermissions } from "../../../Auth"
import { Navigate } from "../../../router-utils"

export default function SuppliersPage() {
	const { hasPermission } = useCheckPermissions()
	const canViewTransPortServiceProviders = hasPermission(
		PERMISSIONS.VIEW_TRANSPORT_SERVICE_PROVIDERS
	)
	const canViewHotelSuppliers = hasPermission(PERMISSIONS.VIEW_HOTEL_SUPPLIERS)
	const canViewVisaSuppliers = hasPermission(PERMISSIONS.MANAGE_VISA_SUPPLIERS)
	if (canViewTransPortServiceProviders)
		return <Navigate to="/suppliers/transport" replace />
	else if (canViewHotelSuppliers)
		return <Navigate to="/suppliers/hotel" replace />
	else if (canViewVisaSuppliers)
		return <Navigate to="/suppliers/visa" replace />
}
